<div id="content">
  <div class="page-title">
    <a mat-button routerLink="/employees/rrhh/job-vacancies">
      <mat-icon>arrow_back</mat-icon>
      Vacantes
    </a>
    @if (job_vacancy(); as vacancy) {
      <h1>{{ vacancy.title }}</h1>
      <div class="title-actions">
        @if (vacancy.offer_url) {
          <a mat-stroked-button [href]="vacancy.offer_url" target="_blank" rel="noopener noreferrer">Ver oferta</a>
        }
        <button mat-flat-button color="accent" type="button" (click)="openEditVacancyDialog()">Editar vacante</button>
      </div>
    }
  </div>

  @if (loading()) {
    <p>Cargando...</p>
  } @else {
    @if (job_vacancy(); as vacancy) {
      <div class="vacancy-summary-grid">
        <article class="card vacancy-summary-card">
          <p class="vacancy-summary-label">Categorías</p>
          <p class="vacancy-summary-value">{{ department_categories_label() }}</p>
        </article>

        <article class="card vacancy-summary-card">
          <p class="vacancy-summary-label">Vigencia</p>
          <p class="vacancy-summary-value">{{ period_label() }}</p>
        </article>

        <article class="card vacancy-summary-card">
          <p class="vacancy-summary-label">Estado</p>
          <p class="vacancy-summary-value">{{ status_label() }}</p>
        </article>

        <article class="card vacancy-summary-card">
          <p class="vacancy-summary-label">Rango salarial</p>
          <p class="vacancy-summary-value">
            @if (vacancy.salary_range; as salary_range) {
              @if (salary_range.min === salary_range.max) {
                {{ salary_range.min | currency: 'EUR' : 'symbol' : '1.0-0' : 'es' }} brutos/año
              } @else {
                {{ salary_range.min | currency: 'EUR' : 'symbol' : '1.0-0' : 'es' }}
                –
                {{ salary_range.max | currency: 'EUR' : 'symbol' : '1.0-0' : 'es' }}
                brutos/año
              }
            } @else {
              —
            }
          </p>
        </article>
      </div>

      <section class="card section">
        <h2>Descripción</h2>
        @if (vacancy.job_description) {
          <div class="job-description rich-html-content" [innerHTML]="vacancy.job_description | trustedHtml"></div>
        } @else {
          <p class="muted">Sin descripción.</p>
        }
      </section>

      <section class="card section">
        <div class="section-header">
          <h2>Pipeline (fases)</h2>
          @if ((vacancy.job_vacancy_phases?.length ?? 0) > 0) {
            <button mat-stroked-button type="button" (click)="openPhasesConfigDialog()">Configurar fases</button>
          }
        </div>
        @if ((vacancy.job_vacancy_phases?.length ?? 0) === 0) {
          <p class="muted">No hay fases configuradas. Edita la vacante para añadir fases al pipeline.</p>
        } @else {
          <app-job-vacancy-phase-trackline [phases]="vacancy.job_vacancy_phases ?? []" [candidates]="pipeline_candidates()" />
        }
      </section>

      <section class="card section">
        <div class="section-header">
          <h2>Candidatos</h2>
          <div class="section-header-actions">
            <mat-form-field appearance="outline" class="candidate-filter-field small">
              <mat-label>Estado</mat-label>
              <mat-select [value]="candidate_filter()" (selectionChange)="onCandidateFilterChange($event)">
                @for (option of candidate_filter_options; track option.value) {
                  <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <button mat-flat-button color="accent" type="button" (click)="openCreateCandidateDialog()">Nuevo candidato</button>
          </div>
        </div>

        <table mat-table [dataSource]="candidates_data_source">
          <ng-container matColumnDef="full_name">
            <th mat-header-cell *matHeaderCellDef>Nombre</th>
            <td mat-cell *matCellDef="let element">
              <a
                mat-button
                class="candidate-name-button"
                [routerLink]="['/employees', 'rrhh', 'job-vacancies', job_vacancy_id, 'candidates', element.id]"
              >
                {{ element.full_name }}
              </a>
              @if (element.is_discarded) {
                <span class="discarded-badge">Descartado</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="user">
            <th mat-header-cell *matHeaderCellDef>Usuario</th>
            <td mat-cell *matCellDef="let element">{{ element.user_label }}</td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>Email</th>
            <td mat-cell *matCellDef="let element">{{ element.email ?? '-' }}</td>
          </ng-container>

          <ng-container matColumnDef="current_phase">
            <th mat-header-cell *matHeaderCellDef>Fase actual</th>
            <td mat-cell *matCellDef="let element">
              @if (!element.is_discarded) {
                <mat-form-field appearance="outline" class="phase-select-field small">
                  <mat-select [value]="element.current_phase_id" (selectionChange)="onCandidatePhaseChange(element, $event)">
                    @for (phase of sorted_vacancy_phases(); track phase.id) {
                      <mat-option [value]="phase.id">{{ phase.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              } @else {
                {{ element.current_phase_label }}
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <div class="candidate-actions">
                <a
                  mat-icon-button
                  matTooltip="Ver candidato"
                  aria-label="Ver candidato"
                  [routerLink]="['/employees', 'rrhh', 'job-vacancies', job_vacancy_id, 'candidates', element.id]"
                >
                  <mat-icon>visibility</mat-icon>
                </a>
                @if (!element.is_discarded) {
                  <button
                    mat-icon-button
                    type="button"
                    color="warn"
                    matTooltip="Descartar candidato"
                    aria-label="Descartar candidato"
                    (click)="discardCandidate(element)"
                  >
                    <mat-icon>person_off</mat-icon>
                  </button>
                }
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="candidates_displayed_columns"></tr>
          <tr mat-row *matRowDef="let row; columns: candidates_displayed_columns"></tr>
        </table>
      </section>
    }
  }
</div>
